import { EventChartRangeEnum } from "~/feature/chart/types";

export const MAX_AXIS_TICKS = 7;

const formatTime = (date: Date) =>
  date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });

const formatDay = (date: Date) =>
  date.toLocaleDateString("en-US", { month: "short", day: "numeric" });

const formatDayHour = (date: Date) => `${formatDay(date)} ${date.getHours()}h`;

const formatByRange: Record<EventChartRangeEnum, (date: Date) => string> = {
  [EventChartRangeEnum.H1]: formatTime,
  [EventChartRangeEnum.H6]: formatTime,
  [EventChartRangeEnum.D1]: formatDayHour,
  [EventChartRangeEnum.W1]: formatDay,
  [EventChartRangeEnum.M1]: formatDay,
  [EventChartRangeEnum.ALL]: formatDay,
};

export const formatAxisLabel = (
  timestamp: number,
  range: EventChartRangeEnum
) => formatByRange[range](new Date(timestamp));

export const getAxisTickIndexes = (pointsCount: number): number[] => {
  if (pointsCount <= 0) {
    return [];
  }

  const count = Math.min(pointsCount, MAX_AXIS_TICKS);

  return Array.from({ length: count }, (_, index) =>
    count === 1 ? 0 : Math.round((index * (pointsCount - 1)) / (count - 1))
  );
};
